import React from 'react';
import { TestLogicFactory } from '../../eye-test/logic/test-logic-factory';
import { TextTestLogic } from '../../eye-test/logic/text-test-logic';
import { GlobalLogic } from '../../shared/logic/global-logic';
import { formatFloatingNumber } from '../../shared/util/functions';
import { getBedarf } from '../util/functions';
import '../styles/all-tests-result.scss';

export function AllTestsResult() {
	const globalLogic = GlobalLogic.getInstance();
	// const eyeTestLogic = TestLogicFactory.getInstanceOf('eye-test-logic');
	// const contrastTestLogic = TestLogicFactory.getInstanceOf('contrast-test-logic');
	const michelsonTestLogic = TestLogicFactory.getInstanceOf('michelson-test-logic');
	const textTestLogic = TextTestLogic.getInstance();

	const lastIdentified = michelsonTestLogic.smallestCorrectLandolt;
	const lastIdentifiedReduced = michelsonTestLogic.smallestCorrectLandoltReducedOpacity;
	const visus = lastIdentified.visusOneMeter * globalLogic.distance / 100;
	const resultDifference = Math.abs(lastIdentified.id - lastIdentifiedReduced.id);

	const bedarf = getBedarf();
	const testSize: number = bedarf[textTestLogic.currentFontSizeIndex];

	const additionalVisus = ((): JSX.Element => {
		if (visus > 1.25) {
			return <>Ausgezeichnete</>;
		}

		if (visus > 1) {
			return <>Sehr gute</>;
		}

		if (visus > 0.8) {
			return <>Gute</>;
		}

		return <>Nicht optimal</>;
	})();

	const additionalContrast = ((): JSX.Element => {
		if (resultDifference <= 3) {
			return <>Nicht eingeschränkt</>;
		}

		if (resultDifference <= 6) {
			return <>Eingeschränkt</>;
		}

		return <>Stark eingeschränkt</>;
	})();

	const text = ((): JSX.Element => {
		if (testSize <= 1) {
			return <>Sehr gute</>;
		}
		return <>Nicht optimal</>;
	})();

	return (
		<div className={'all-tests--wrapper'}>
			<div>
				<p><strong>Visus</strong></p>
				<p>~ {formatFloatingNumber(visus)}</p>
				<p>{additionalVisus}</p>
			</div>
			<div>
				<p><strong>Kontrastsehen</strong></p>
				<p>{resultDifference} Stufen</p>
				<p>{additionalContrast}</p>
			</div>
			<div>
				<p><strong>Vergrößerungsbedarf</strong></p>
				<p>{formatFloatingNumber(testSize)}x</p>
				<p>{text}</p>
			</div>
		</div>
    );
}
